module.exports = __webpack_public_path__ + "assets/img/v1.cecec55c.png";